import React, { Component } from "react";
import MapFiltersHolder from "./Styles/mapFiltersStyle";
import {
  Row,
  Col,
  Icon,
  List,
  Input,
  Collapse,
  Divider,
  Button,
  Card,
  Checkbox,
  Spin,
  Tooltip,
} from "antd";
import Colors from "../themes/Colors";
import CheckboxButton from "./customComponents/CheckboxButton/CheckboxButton";
import { poiCategories } from "../services/utils";
import { withTranslation } from "react-i18next";

const Search = Input.Search;
const Panel = Collapse.Panel;
const CheckSearch = Card;
class MapFiltersComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      appliedFilters: [],
      typedPlace:"",
    };
  }

  componentDidMount = () => {
    this.props.resetPoiFilters();
  }


  handleFilters = (filter) => {
    const { refreshDisplays, setPoiFilters} = this.props;
    const { appliedFilters } = this.state;
    let filterIncludes = appliedFilters.includes(filter);
    let newArr = null;
    if (filterIncludes) {
      newArr = appliedFilters.filter((item) => item !== filter);
    } else {
      newArr = [...appliedFilters, filter];
    }
    setPoiFilters(newArr);
    refreshDisplays(newArr);
    this.setState({appliedFilters: newArr});
  }

  handleChangePlace = (place) => {
    this.setState({typedPlace: place});
    if (place === "")
      this.props.handleSelectPlace(place);
  }

  removePins = () => {
    this.setState({ typedPlace: "" });
    this.props.handleSelectPlace("");
  }

  render() {
    const {
      t,
      handleSelectPlace,
      checkSearchMap,
      setCheckSearchMap,
      fetching,
      onOpenAddByIdModal,
    } = this.props;
    const { typedPlace } = this.state;
    const customPanelStyle = {
      backdropFilter: "blur(2px)",
      border: 0,
      overflow: "hidden",
      background: "rgba(0, 0, 0, 0.1)",
      borderRadius: "8px",
      textAlign: "-webkit-center"
    };
    return (
      <MapFiltersHolder>
        <Row
          type="flex"
          width="100%"
          height="200px"
          className="mapFiltersContainer"
          style={{ pointerEvents: "none" }}
        >
          <Col
            xs={24}
            sm={24}
            md={24}
            lg={16}
            xl={9}
            style={{ pointerEvents: "all" }}
            className="customCol"
          >
            <Collapse
              bordered={false}
              style={{ background: "transparent", width: "100%" }}
            >
              <Panel header={t("Map filters")} key="1" style={customPanelStyle}>
                <List
                  grid={{ gutter: 3, column: 3, xxl: 3 }}
                  dataSource={poiCategories}
                  renderItem={(item) => (
                    <List.Item style={{ height: "32px", fontSize: "12px" }}>
                      <CheckboxButton
                        filter={item.slug}
                        label={t(`${item.name}`)}
                        icon={item.icon}
                        setFilter={this.handleFilters}
                      />
                    </List.Item>
                  )}
                />
                <Divider style={{ margin: "15px 0px 10px 0px" }} />
                <Row type="flex" justify="space-between">
                  <Col xs={18} sm={18} md={18} lg={18} xl={18}>
                    <Search
                      placeholder={t("Search by place")}
                      onChange={(e) => this.handleChangePlace(e.target.value)}
                      onSearch={() => handleSelectPlace(typedPlace)}
                      value={typedPlace}
                      enterButton
                      allowClear
                      onPressEnter={() => handleSelectPlace(typedPlace)}
                    />
                  </Col>
                  <Col xs={6} sm={6} md={6} lg={6} xl={6} style={{ display: "flex", justifyContent: "flex-end" }}>
                    <Button onClick={this.removePins} style={{ borderRadius: "8px"}} disabled={typedPlace === ""}>
                      <Icon type="delete" />
                      Pins
                    </Button>
                  </Col>
                </Row>
              </Panel>
            </Collapse>
          </Col>
          {/* IDs button + "Search on move" grouped as one block, pushed to
              the right of the row via marginLeft: auto. */}
          <Col
            className="filterActionsBlock"
            style={{
              pointerEvents: "all",
              display: "flex",
              alignItems: "center",
              gap: 8,
            }}
          >
            <Tooltip title={t("Add screens by ID")}>
              <Button
                size="large"
                onClick={onOpenAddByIdModal}
                style={{
                  backgroundColor: Colors.snow,
                  borderColor: Colors.primaryAccent,
                  color: Colors.primaryAccent,
                  borderRadius: 8,
                  fontWeight: 500,
                  height: 46,
                }}
              >
                + IDs
              </Button>
            </Tooltip>
            <CheckSearch style={{ width: "100%" }} className="customCheckStyle">
              <Spin spinning={fetching}>
                <Checkbox
                  onChange={setCheckSearchMap}
                  defaultChecked={checkSearchMap}
                  value={checkSearchMap}>
                      <span style={{fontSize:"smaller"}}>
                        {t("Search on move")}
                      </span>
                </Checkbox>
              </Spin>
            </CheckSearch>
          </Col>
        </Row>
      </MapFiltersHolder>
    );
  }
}
export default withTranslation()(MapFiltersComponent);
